document.documentElement.classList.replace('no-js', 'js');
document.addEventListener('change', (event) => {
  if (!event.target.matches('[data-variant-picker]')) return;
  const section = event.target.closest('[data-product-section]');
  const selected = event.target.selectedOptions[0];
  document.querySelectorAll('[data-product-price]').forEach(price => { price.textContent = selected.dataset.price; });
  const button = section.querySelector('[data-add-to-cart]');
  button.disabled = selected.dataset.available !== 'true';
  button.textContent = button.disabled ? 'Indisponible' : 'Acheter maintenant ↗';
});

function initNuitigoGalleries(root=document){
  root.querySelectorAll('[data-gallery-wrap]').forEach(w=>{
    if(w.dataset.ready)return;
    const g=w.querySelector('[data-gallery]');
    if(!g||!g.children.length)return;
    w.dataset.ready='true';
    const slides=[...g.children],thumbs=[...w.querySelectorAll('[data-gallery-index]')];
    const count=w.querySelector('[data-gallery-count]'),caption=w.querySelector('[data-gallery-caption]');
    const prev=w.querySelector('[data-gallery-prev]'),next=w.querySelector('[data-gallery-next]');
    let active=0,targetIndex=0,navigating=false,settleTimer;
    const clamp=i=>Math.max(0,Math.min(slides.length-1,i));
    function syncButtons(){
      const index=navigating?targetIndex:active;
      if(prev)prev.disabled=index===0;
      if(next)next.disabled=index===slides.length-1;
    }
    function sync(){
      active=clamp(Math.round(g.scrollLeft/Math.max(g.clientWidth,1)));
      if(!navigating)targetIndex=active;
      if(count)count.textContent=`${active+1} / ${slides.length}`;
      if(caption)caption.textContent=slides[active]?.dataset.caption||'';
      thumbs.forEach((t,i)=>t.setAttribute('aria-pressed',String(i===active)));
      syncButtons();
    }
    function settle(){
      window.clearTimeout(settleTimer);
      navigating=false;
      sync();
    }
    function scheduleSettle(){
      window.clearTimeout(settleTimer);
      settleTimer=window.setTimeout(settle,180);
    }
    function go(i){
      // Keep the requested destination separate from intermediate smooth-scroll
      // frames, so rapid clicks advance once per click instead of being lost.
      targetIndex=clamp(i);
      navigating=true;
      syncButtons();
      g.scrollTo({left:targetIndex*g.clientWidth,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
      scheduleSettle();
    }
    prev?.addEventListener('click',()=>go(targetIndex-1));
    next?.addEventListener('click',()=>go(targetIndex+1));
    thumbs.forEach((t,i)=>t.addEventListener('click',()=>go(i)));
    g.addEventListener('scroll',()=>{sync();scheduleSettle();},{passive:true});
    g.addEventListener('scrollend',()=>{
      // Ignore the end of an older animation if a newer destination is pending.
      if(!navigating||Math.abs(g.scrollLeft-targetIndex*g.clientWidth)<1)settle();
    });
    // A manual gesture takes over from any queued destination.
    ['pointerdown','touchstart','wheel','keydown'].forEach(name=>g.addEventListener(name,settle,{passive:true}));
    window.addEventListener('resize',settle);
    sync();
  });
}
initNuitigoGalleries();document.addEventListener('shopify:section:load',e=>initNuitigoGalleries(e.target));

function initNuitigoOffer(root=document){
  const product=root.querySelector('[data-product-section]');
  const reminder=document.querySelector('[data-mobile-offer]');
  if(!product||!reminder||product.dataset.offerReady||!('IntersectionObserver' in window))return;
  product.dataset.offerReady='true';
  const offer=product.querySelector('[data-add-to-cart]')||product.querySelector('#achat-nuitigo .n-button');
  if(!offer)return;
  const heading=product.querySelector('.n-product-heading');
  const mobile=window.matchMedia('(max-width:749px)');
  let offerVisible=false,headingAbove=false;
  function update(){reminder.hidden=!(mobile.matches&&headingAbove&&!offerVisible);}
  const observer=new IntersectionObserver(entries=>{
    entries.forEach(entry=>{if(entry.target===offer)offerVisible=entry.isIntersecting&&entry.intersectionRatio>=1;else headingAbove=entry.boundingClientRect.bottom<=0;});update();
  },{threshold:[0,1],rootMargin:"0px 0px -88px 0px"});
  observer.observe(offer);observer.observe(heading);mobile.addEventListener('change',update);
  function cleanup(e){if(!e.target.contains(product))return;observer.disconnect();mobile.removeEventListener('change',update);reminder.hidden=true;document.removeEventListener('shopify:section:unload',cleanup);}
  document.addEventListener('shopify:section:unload',cleanup);
}
initNuitigoOffer();document.addEventListener('shopify:section:load',e=>initNuitigoOffer(e.target));

// Open the useful measurements when a shopper arrives from the fit guide.
function openNuitigoDimensions(){
  if(window.location.hash!=='#NuitigoContactDimensions')return;
  const details=document.querySelector('[data-contact-dimensions]');
  if(details)details.open=true;
}
openNuitigoDimensions();
window.addEventListener('hashchange',openNuitigoDimensions);
